// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"appointments__DownloadCSV__downloadButton"};